import { Box, Divider, Flex, Heading, Text } from "@chakra-ui/react";
import React from "react";
import IsDesktop from "../../../utils/IsDesktop";

const PitchRequestCountCard = ({data}) => {
    const isDesktop = IsDesktop();

    return (
        <>
            <Box h="100px" className="w-fit flex flex-col gap-4 p-5" p={5} boxShadow="0px 1px 8px lightgray" borderRadius="10px" >
                <Text fontWeight={700} fontSize="18px" color="brand.primary">
                    No. of Pitches
                </Text>
                    <Text className="text-xl font-semibold text-center font-bold">{data}</Text>
            
            </Box>
        </>
    )
}
export default PitchRequestCountCard;